export const INITIAL_PROGRESS = 0;
export const PROGRESS_INTERVAL = 100;
export const MAX_DIFF_VALUE = 10;
export const MAX_PROGRESS_VALUE = 90;
